import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import _ from 'lodash'
import { ADMIN } from '../../../constants/roles'

export default function withAuth(Component) {
  return connect(({ auth }) => ({
    auth,
  }))(function Auth(props) {
    if (!props.auth.isPrepared || props.auth.isFetching) {
      return <div>Loading</div>
    }
    if (props.auth.isLoggedIn) {
      if (checkIfAnyGrantedByGivenAuth(props.auth, props.ifAnyGranted)) {
        return <Component {...props} />
      } else {
        return <Redirect to="/" />
      }
    } else {
      return <Redirect to="/login" />
    }
  })
}

export const checkIfAnyGrantedByGivenAuth = (authState, roles = []) => {
  return (
    authState.isLoggedIn &&
    _.intersection(authState.user.roles, [...roles, ADMIN]).length > 0
  )
}



// WEBPACK FOOTER //
// ./src/components/templates/route-management/withAuth.js